import Text from './Text';
import { TextColor, TextWeight, TextSize, getSize, getColor, getWeight } from './utils';

export default function XlSemibold(props) {
  return (
    <Text
      {...props}
      size={TextSize.Xl}
      weight={TextWeight.Semibold}
    />
  );
}
